import script from "./AiCustomerService.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiCustomerService.vue?vue&type=script&setup=true&lang=ts"

import "./AiCustomerService.vue?vue&type=style&index=0&id=e8008d72&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8008d72"]])

export default __exports__